import { defineAIProviderManifest } from "../manifest";
import { OPENAI_CONTEXT_LIMIT_PATTERNS } from "../openai/manifest";

export const OPENAI_COMPATIBLE_CONTEXT_LIMIT_PATTERNS: readonly string[] = [
  ...OPENAI_CONTEXT_LIMIT_PATTERNS,
  "exceed_context_size_error",
  "exceeds the available context size",
];

export const manifest = defineAIProviderManifest({
  id: "openai-compatible",
  label: "Custom",
  description:
    "Legacy custom endpoint. New providers should use OpenAI compatible.",
  connectorIdentifier: "apiKey",
  defaultChatModel: "chat-model",
  defaultFastModel: "fast-model",
  configurable: true,
  retired: true,
  requiresChatModel: true,
  contextLimitPatterns: OPENAI_COMPATIBLE_CONTEXT_LIMIT_PATTERNS,
  reasoningReplay: { via: "text" },
  credentialFields: [
    {
      key: "baseUrl",
      label: "Base URL",
      description: "Required. Use your provider's API base URL.",
      placeholder: "https://llm.example.com/v1",
      required: true,
    },
    {
      key: "apiKey",
      label: "API key",
      description: "Stored securely on the server.",
      placeholder: "sk-…",
      sensitive: true,
    },
  ],
  packCredentials: (v) => ({
    baseUrl: v.baseUrl?.trim() ?? "",
    apiKey: v.apiKey?.trim() ?? "",
  }),
  unpackCredentials: (row) => ({ baseUrl: row.baseUrl, apiKey: "" }),
  subtitleField: "baseUrl",
  attachmentSupport: {
    documentMediaTypes: ["application/pdf"],
    maxImageDimension: 2000,
  },
});
